import styled from 'styled-components'

import ImagePaths from '../../../utils/constants/ImagePaths'

export const StyledHelloFavRoute = styled.div`
  background: linear-gradient(253.87deg, #fff6f1 -4.3%, #d2d2ff 318.65%);
  text-align: center;
  padding-bottom: ${props => props.theme.spacing.xlarge};
  padding-inline: ${props => props.theme.spacing.default};

  h1 {
    margin-bottom: ${props => props.theme.spacing.medium};
    font-weight: ${props => props.theme.fontWeight.medium};
    font-size: ${props => props.theme.font.xlarge};
    padding-inline: ${props => props.theme.spacing.medium};
  }

  // TODO: Add common style into yolda-web-ui
  button {
    span {
      font-weight: ${props => props.theme.fontWeight.medium};
      display: flex;
      align-items: center;
      justify-content: center;
      gap: ${props => props.theme.spacing.default};
    }
  }
`

export const HelloFavRouteTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 10.5rem;
  background-image: url(${ImagePaths.favRoutes['modalTopBg']});
  margin-bottom: ${props => props.theme.spacing.medium};

  img {
    height: 96px;
  }
`
